var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
import * as React from 'react';
import styled from 'styled-components';
import ReactResizeDetector from 'react-resize-detector';
var Root = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  z-index: 10000;\n  top: 50%;\n  left: 50%;\n"], ["\n  position: fixed;\n  z-index: 10000;\n  top: 50%;\n  left: 50%;\n"])));
var ModalWrapper = /** @class */ (function (_super) {
    __extends(ModalWrapper, _super);
    function ModalWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = React.createRef();
        _this.getWidth = function (width, height) {
            if (_this.modal.current && width && height) {
                _this.modal.current.style.marginTop = height / -2 + "px";
                _this.modal.current.style.marginLeft = width / -2 + "px";
            }
        };
        return _this;
    }
    ModalWrapper.prototype.render = function () {
        return (React.createElement(Root, { ref: this.modal },
            React.Children.only(this.props.children),
            React.createElement(ReactResizeDetector, { handleHeight: true, handleWidth: true, onResize: this.getWidth })));
    };
    return ModalWrapper;
}(React.Component));
export default ModalWrapper;
var templateObject_1;
//# sourceMappingURL=ModalWrapper.js.map